import React from "react";
import { Link } from "react-router-dom";
import { Lock, ShieldCheck } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="bg-[#050505] min-h-screen flex items-center justify-center text-white px-6">
      <div className="w-full max-w-md">
        <div className="font-display text-xs tracking-[0.3em] text-[#D10000] mb-4 flex items-center gap-2">
          <ShieldCheck className="h-4 w-4" /> PRIMENAX · CONTROL
        </div>
        <h1
          className="font-display uppercase leading-[0.9] tracking-tight mb-6"
          style={{ fontSize: "clamp(2.5rem, 6vw, 4rem)" }}
        >
          Admin
          <br />
          <span className="text-stroke">Access.</span>
        </h1>
        <p className="text-white/55 mb-10 leading-relaxed">
          This area is restricted to the brand owner. Sign in with your
          authorized Google account to view sales, fulfillment, and analytics.
        </p>

        <button
          type="button"
          onClick={handleLogin}
          data-testid="admin-google-login-button"
          className="group w-full inline-flex items-center justify-center gap-3 bg-white text-black font-display tracking-widest uppercase py-4 px-6 hover:bg-white/90 transition-colors"
        >
          <GoogleIcon />
          Sign in with Google
        </button>

        <div className="mt-6 flex items-center gap-2 text-xs text-white/40">
          <Lock className="h-3 w-3" />
          Auth handled by Emergent · session secured 7 days
        </div>

        <Link
          to="/"
          data-testid="admin-back-to-site-link"
          className="mt-10 inline-block font-display tracking-widest uppercase text-xs text-white/40 hover:text-white"
        >
          ← Back to site
        </Link>
      </div>
    </div>
  );
}

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" className="h-5 w-5" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.7-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.1 29.4 4 24 4 12.95 4 4 12.95 4 24s8.95 20 20 20 20-8.95 20-20c0-1.3-.1-2.4-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.3 6.1 29.4 4 24 4 16.3 4 9.6 8.4 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.2C29.3 35 26.7 36 24 36c-5.3 0-9.7-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.3-4 5.7l6.3 5.2C41.5 35.4 44 30 44 24c0-1.3-.1-2.4-.4-3.5z"/>
  </svg>
);
